import * as React from "react";
import { useLayoutEffect, useRef } from "react";
import { useStickyBottom } from "../../../../hooks/useStickyBottom";

/**
 * Rendered inside the job page's sticky header, so it mounts with that header — which loads after the job —
 * and measures where it ends for the history to stick right below.
 */
export const SubHeader: React.FC<{ onJobHeaderBottom: (bottom: number) => void }> = ({
  onJobHeaderBottom,
  children,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const jobHeaderBottom = useStickyBottom(() => ref.current?.closest("header") as HTMLElement | null);
  useLayoutEffect(() => onJobHeaderBottom(jobHeaderBottom), [jobHeaderBottom, onJobHeaderBottom]);
  return (
    <div ref={ref} className="bg-[#1f2b3a] border-t border-[#44576e]">
      {children}
    </div>
  );
};
